import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
    selector: 'cp-monthly-invoice-sales-detail',
    templateUrl: './monthly-invoice-sales-detail.component.html',
    styleUrls: ['./monthly-invoice-sales-detail.component.scss'],
    standalone: false
})
export class MonthlyInvoiceSalesDetailComponent implements OnInit {

    constructor() { }

    @Input() chartType: string = 'line';
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.monthlyInvoiceSalesDetail;
    chartSearchFilters: widgetFilters[] = [widgetFilters.customer,  
        widgetFilters.locations,
        widgetFilters.salesPerson,
        widgetFilters.technicians,
        widgetFilters.invoiceStatus,
        widgetFilters.class,
        widgetFilters.dateRange,
        widgetFilters.onCallRegion,       
        widgetFilters.invoiceSalesSummaryTypes];

    ngOnInit() {
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
        //
    }

}
